"use client";
import React, { useRef, useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";

const AudioWaveform = ({ audioUrl, pageType }) => {
  const waveformRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [wavesurfer, setWavesurfer] = useState(null);

  const [currentTime, setCurrentTime] = useState(0);
  const [currentDuration, setCurrentDuration] = useState(0);

  let waveInstance;
  const isPodcast = pageType === "Podcast";

  useEffect(() => {
    // Initialize Wavesurfer when the component mounts
    waveInstance = WaveSurfer.create({
      container: waveformRef?.current && waveformRef.current,
      waveColor: "#C3C0C0",
      progressColor: `${isPodcast ? "#7BFF88" : "#6260FA"}`,
      barGap: 5,
      barWidth: 6,
      barRadius: 10,
      height: `${isPodcast ? 40 : 55}`,
    });
    setWavesurfer(waveInstance);
    // Clean up Wavesurfer instance when the component unmounts
    return () => waveInstance.destroy();
  }, [audioUrl]);

  useEffect(() => {
    if (wavesurfer) {
      wavesurfer.load(audioUrl);
      wavesurfer.on("interaction", () => {
        wavesurfer.play();
        setPlaying(true);
      });
      wavesurfer.on("finish", () => setPlaying(false));
      wavesurfer.on("audioprocess", () => {
        setCurrentTime(
          (wavesurfer.getCurrentTime() / wavesurfer.getDuration()) * 100
        );
      });
    }
  }, [wavesurfer]);

  const play = () => {
    if (wavesurfer) {
      wavesurfer?.play();
      setPlaying(true);
    }
  };
  const pause = () => {
    if (wavesurfer) {
      wavesurfer?.pause();
      setPlaying(false);
    }
  };

  const progress = Math.round(currentTime);

  return (
    <div className="p-3 flex justify-center  gap-4 items-center">
      <div
        onClick={playing ? pause : play}
        className={`bg-[#ffffff36] rounded-full ${
          isPodcast ? " radial-progress" : ""
        } text-[#7BFF88]`}
        style={{ "--value": `${progress}` }}
        role="progressbar"
      >
        <button
          className={` bg-gradient-to-tr text-white from-[#00ECD4] to-[#6260FA]  ${
            isPodcast ? "p-4" : "p-0"
          } rounded-full`}
        >
          {playing ? (
            <div className={`${isPodcast ? "" : " p-4"}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={`${
                  isPodcast ? "w-7 h-7" : "w-12 h-12"
                } pointer-events-none`}
              >
                <path
                  fill-rule="evenodd"
                  d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          ) : isPodcast ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className={`w-7 h-7 pointer-events-none`}
            >
              <path
                fill-rule="evenodd"
                d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                clip-rule="evenodd"
              />
            </svg>
          ) : (
            <img
              src="/Images/voicePlay.png"
              alt="blog voice play icon"
              className="w-20"
            />
          )}
        </button>
      </div>

      <div
        className={`${
          pageType === "Blog"
            ? "w-[250px] sm:w-[350px] md:w-[450px] lg:w-[500px] xl:w-[650px]"
            : "w-[220px] sm:w-[290px] md:[330px]"
        }`}
      >
        <div ref={waveformRef} style={{ width: "100%" }} />
      </div>
    </div>
  );
};

export default AudioWaveform;
